// REMIX HMR BEGIN
if (!window.$RefreshReg$ || !window.$RefreshSig$ || !window.$RefreshRuntime$) {
  console.warn('remix:hmr: React Fast Refresh only works when the Remix compiler is running in development mode.');
} else {
  var prevRefreshReg = window.$RefreshReg$;
  var prevRefreshSig = window.$RefreshSig$;
  window.$RefreshReg$ = (type, id) => {
    window.$RefreshRuntime$.register(type, "\"app/components/node/NodePage.tsx\"" + id);
  }
  window.$RefreshSig$ = window.$RefreshRuntime$.createSignatureFunctionForTransform;
}
import * as __hmr__ from "remix:hmr";
if (import.meta) {
  import.meta.hot = __hmr__.createHotContext(
  //@ts-expect-error
  "app/components/node/NodePage.tsx");
  import.meta.hot.lastModified = "1773385375629.633";
}
// REMIX HMR END

import { Fragment } from "react";
import { componentResolver } from "~/components/helpers/componentResolver";
import Primary from "~/components/layout/Primary";
import Tertiary from "~/components/layout/Tertiary";
export default function NodePageComponent({
  node,
  environment
}) {
  const isToCPage = node.showTableOfContent;
  const components = componentResolver(node.components || [], isToCPage ? "tertiary" : "primary", environment);
  if (isToCPage) {
    return <Tertiary node={node}>
        {components.map((component, index) => {
        return <Fragment key={index}>{component}</Fragment>;
      })}
      </Tertiary>;
  }
  return <Primary node={node}>
      {components.map((component, index) => {
      return <Fragment key={index}>{component}</Fragment>;
    })}
    </Primary>;
}
_c = NodePageComponent;
var _c;
$RefreshReg$(_c, "NodePageComponent");

window.$RefreshReg$ = prevRefreshReg;
window.$RefreshSig$ = prevRefreshSig;